export default __webpack_public_path__ + "static/sardines-05efc3e5435cd3e70c4ded877cb3d580.jpg";